import { ServiceConfig } from '../models/service-config.model';

export const MOCK_SERVICE_CONFIGS: ServiceConfig[] = [
  {
    pagerDutyServiceId: "PORTAL-001",
    pagerDutyServiceName: "Customer Portal API",
    pagerDutyTeamId: "PORTAL-TEAM-ID",
    pagerDutyTeamName: "PORTAL-TEAM-NAME",
    serviceIntegrationManagementServiceOffering: "910500_PORTAL_TRADE",
    serviceIntegrationManagementBusinessService: "Customer Portal Service",
    serviceIntegrationManagementAssignmentGroup: "A.T.GLOB.CPI.PORTAL-IT-ALERT",
    emailDistributionList: ["portal@allianz-trade.com", "support@allianz-trade.com"],
    jiraProjectId: "PORTAL",
    contactEmail: "portal@allianz-trade.com",
    collaborativePlatformGroupId: "GRP-PORTAL-001",
    collaborativePlatformChannelId: "CH-PORTAL-ALERTS",
    creationDateTime: "2024-01-15T09:00:00Z",
    createdby: "john.doe@allianz-trade.com",
    lastUpdateDateTime: "2025-03-10T14:30:00Z",
    lastUpdatedby: "jane.smith@eulerhermes.com",
    applications: [
      {
        applicationId: 'PZD3YL8',
        applicationName: 'Example API',
        contactEmail: 'unai.manzanoperez.ext@allianz-trade.com',
        emailDistributions: ['frontend-team@allianz-trade.com', 'portal-alerts@allianz-trade.com'],
        features: [
          {
            featureId: 'FEAT-001',
            featureName: 'User Dashboard',
            contactEmail: 'dashboard-team@eulerhermes.com',
            emailDistributions: ['dashboard-alerts@eulerhermes.com']
          },
          {
            featureId: 'FEAT-002',
            featureName: 'Profile Management',
            contactEmail: 'profile-team@allianz.com',
            emailDistributions: ['profile-alerts@allianz.com', 'user-mgmt@allianz.com']
          }
        ]
      },
      {
        applicationId: 'APP-002',
        applicationName: 'Customer Portal Backend',
        contactEmail: 'portal-backend@allianz-trade.com',
        emailDistributions: ['backend-team@allianz-trade.com', 'api-alerts@allianz-trade.com'],
        features: [
          {
            featureId: 'FEAT-003',
            featureName: 'API Gateway',
            contactEmail: 'gateway-team@eulerhermes.com',
            emailDistributions: ['gateway-alerts@eulerhermes.com']
          }
        ]
      },
      {
        applicationId: 'APP-011',
        applicationName: 'Portal Mobile App',
        contactEmail: 'portal-mobile@allianz-trade.com',
        emailDistributions: ['mobile-team@allianz-trade.com', 'ios-dev@allianz-trade.com', 'android-dev@allianz-trade.com'],
        features: [
          {
            featureId: 'FEAT-017',
            featureName: 'Push Notifications',
            contactEmail: 'push-notif@allianz-trade.com',
            emailDistributions: ['notification-alerts@allianz-trade.com']
          },
          {
            featureId: 'FEAT-018',
            featureName: 'Offline Mode',
            contactEmail: 'offline-mode@allianz-trade.com',
            emailDistributions: ['mobile-alerts@allianz-trade.com']
          }
        ]
      },
      {
        applicationId: 'APP-012',
        applicationName: 'Portal Admin Console',
        contactEmail: 'portal-admin@allianz-trade.com',
        emailDistributions: ['admin-team@allianz-trade.com', 'backoffice@allianz-trade.com'],
        features: [
          {
            featureId: 'FEAT-019',
            featureName: 'User Management',
            contactEmail: 'user-admin@allianz.com',
            emailDistributions: ['user-admin-alerts@allianz.com']
          },
          {
            featureId: 'FEAT-020',
            featureName: 'Content Management',
            contactEmail: 'cms-team@eulerhermes.com',
            emailDistributions: ['cms-alerts@eulerhermes.com']
          },
          {
            featureId: 'FEAT-021',
            featureName: 'Audit Logs',
            contactEmail: 'audit-logs@allianz.com',
            emailDistributions: ['compliance@allianz.com', 'security@allianz.com']
          }
        ]
      }
    ]
  },
  {
    pagerDutyServiceId: "PAY-001",
    pagerDutyServiceName: "Payment API",
    pagerDutyTeamId: "PAYMENT-TEAM-ID",
    pagerDutyTeamName: "PAYMENT-TEAM-NAME",
    serviceIntegrationManagementServiceOffering: "910500_PAYMENT_TRADE",
    serviceIntegrationManagementBusinessService: "Payment Service",
    serviceIntegrationManagementAssignmentGroup: "A.T.GLOB.CPI.PAY-IT-ALERT",
    emailDistributionList: ["payment@eulerhermes.com", "finance@eulerhermes.com", "alerts@eulerhermes.com"],
    jiraProjectId: "PAY",
    contactEmail: "payment@eulerhermes.com",
    collaborativePlatformGroupId: "GRP-PAY-001",
    collaborativePlatformChannelId: "CH-PAY-ALERTS",
    creationDateTime: "2024-02-20T10:00:00Z",
    createdby: "gabriel.martin@allianz-trade.com",
    lastUpdateDateTime: "2025-01-05T11:15:00Z",
    lastUpdatedby: "john.doe@allianz-trade.com",
    applications: []
  },
  {
    pagerDutyServiceId: "USER-001",
    pagerDutyServiceName: "User Management API",
    pagerDutyTeamId: "USER-TEAM-ID",
    serviceIntegrationManagementServiceOffering: "910500_USER_TRADE",
    serviceIntegrationManagementBusinessService: "User Management Service",
    serviceIntegrationManagementAssignmentGroup: "A.T.GLOB.CPI.USER-IT-ALERT",
    emailDistributionList: ["user@allianz.com"],
    jiraProjectId: "USER",
    contactEmail: "user@allianz.com",
    collaborativePlatformGroupId: null,
    collaborativePlatformChannelId: null,
    creationDateTime: "2024-03-01T08:30:00Z",
    createdby: "jane.smith@eulerhermes.com",
    lastUpdateDateTime: "2024-11-20T16:45:00Z",
    lastUpdatedby: "jane.smith@eulerhermes.com",
    applications: []
  },
  {
    pagerDutyServiceId: "NOTIF-001",
    pagerDutyServiceName: "Notification Service API",
    pagerDutyTeamId: "NOTIFICATION-TEAM-ID",
    serviceIntegrationManagementServiceOffering: "910500_NOTIF_TRADE",
    serviceIntegrationManagementBusinessService: "Email & SMS Notification Service",
    serviceIntegrationManagementAssignmentGroup: "A.T.GLOB.CPI.NOTIF-IT-ALERT",
    emailDistributionList: ["notification@allianz-trade.com", "sms-alerts@cpic-eh.com", "email-alerts@allianz-trade.com"],
    jiraProjectId: "NOTIF",
    contactEmail: "notification@allianz-trade.com",
    collaborativePlatformGroupId: "GRP-NOTIF-001",
    collaborativePlatformChannelId: "CH-NOTIF-GENERAL",
    creationDateTime: "2024-04-10T13:00:00Z",
    createdby: "john.doe@allianz-trade.com",
    lastUpdateDateTime: "2025-02-14T09:20:00Z",
    lastUpdatedby: "gabriel.martin@allianz-trade.com",
    applications: []
  },
  {
    pagerDutyServiceId: "AUTH-001",
    pagerDutyServiceName: "Authentication Service",
    pagerDutyTeamId: "AUTH-TEAM-ID",
    serviceIntegrationManagementServiceOffering: "910500_AUTH_TRADE",
    serviceIntegrationManagementBusinessService: "OAuth & Identity Management",
    serviceIntegrationManagementAssignmentGroup: "A.T.GLOB.CPI.AUTH-IT-ALERT",
    emailDistributionList: ["auth@allianz.com", "security@allianz.com"],
    jiraProjectId: "AUTH",
    contactEmail: "auth@allianz.com",
    collaborativePlatformGroupId: "GRP-AUTH-001",
    collaborativePlatformChannelId: "CH-AUTH-SECURITY",
    creationDateTime: "2024-01-08T07:00:00Z",
    createdby: "jane.smith@eulerhermes.com",
    lastUpdateDateTime: "2025-03-28T17:00:00Z",
    lastUpdatedby: "john.doe@allianz-trade.com",
    applications: []
  },
  {
    pagerDutyServiceId: "REPORT-001",
    pagerDutyServiceName: "Reporting Engine API",
    pagerDutyTeamId: "ANALYTICS-TEAM-ID",
    serviceIntegrationManagementServiceOffering: "910500_REPORT_TRADE",
    serviceIntegrationManagementBusinessService: "Business Intelligence & Analytics",
    serviceIntegrationManagementAssignmentGroup: "A.T.GLOB.CPI.REPORT-IT-ALERT",
    emailDistributionList: ["reports@allianz-trade.com", "analytics@allianz-trade.com", "bi-team@allianz-trade.com"],
    jiraProjectId: "REPORT",
    contactEmail: "reports@allianz-trade.com",
    collaborativePlatformGroupId: null,
    collaborativePlatformChannelId: null,
    creationDateTime: "2024-06-15T11:30:00Z",
    createdby: "gabriel.martin@allianz-trade.com",
    lastUpdateDateTime: "2025-04-01T13:45:00Z",
    lastUpdatedby: "jane.smith@eulerhermes.com",
    applications: []
  }
];
